import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { useEffect } from "react";
import { toast } from "react-toastify";

export const getProcurementsForCurrentUser = createAsyncThunk(
  "getProcurementsForCurrentUser",
  async () => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/procurement/detailbycompany`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error.message);
    }
  }
);

const ProcurementSlice = createSlice({
  name: "procurement",
  initialState: {
    appliedList: [],
    status: "idle",
    isloading: true,
    error: null,
  },
  reducers: {},
  extraReducers: {
    [getProcurementsForCurrentUser.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getProcurementsForCurrentUser.fulfilled]: (state, action) => {
      state.status = "success";
      state.appliedList = action.payload;
      state.isloading = false;
    },
    [getProcurementsForCurrentUser.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
  },
});

export default ProcurementSlice.reducer;
